(function($){

	$(document).ready(function(){

		$('#videoModal').on('show.bs.modal',function(e){
			$video_src = e.relatedTarget.getAttribute('data-video-src');
			$video_src = $video_src + '?autoplay=1';
			$('#videoModal').find('#video-embed').attr('src', $video_src);
		});

		$('#videoModal').on('shown.bs.modal',function(e){
			
		});

		$('#videoModal').on('hidden.bs.modal',function(e){
			$('#videoModal').find('#video-embed').attr('src', '');
		});

	});




	
})(jQuery);